import { Location } from "history";
import { Field } from "redux-form/immutable";

import { Box, Button, Heading, Stack, Text } from "@seneca/senekit";

import { ErrorMessage as ErrorMessageType } from "services/firebase/auth/errorTranslator";

import { isSignedIn } from "seneca-common/features/user/state";
import { useSelectorWithArgs } from "seneca-common/utils/hooks/selectors";

import { isMobile } from "features/common/utils/functions/mobile";
import { FormTextInput } from "features/forms/components/FormTextInput";
import ErrorMessage from "features/sign-up/components/ErrorMessage";

import ResetPasswordBottomLink from "./ResetPasswordBottomLink";

const mobile = isMobile();

type Props = {
  handleSubmit: () => void;
  signInLink: Location;
  signedIn: boolean;
  submitting?: boolean;
  error?: ErrorMessageType;
};

export default function ResetPasswordForm({
  handleSubmit,
  signInLink,
  submitting,
  error
}: Props) {
  const signedIn = useSelectorWithArgs(isSignedIn);
  return (
    <Box dataTest="SignUpFormWrapper">
      <Stack align="center" space="xlarge">
        <Stack align="center" space="xlarge">
          <Heading level="3" align="center">
            Set a new password
          </Heading>
          <Text size="small" weight="bold" align="center">
            Enter the email you used to sign up and we will send you a link to
            set a new password
          </Text>
        </Stack>

        <Box component="form" onSubmit={handleSubmit} width="100%">
          <Stack space="xlarge">
            <Field
              name="email"
              component={FormTextInput}
              type="email"
              label="Email"
              autoFocus={!mobile}
            />

            {error && <ErrorMessage>{error?.message}</ErrorMessage>}

            <Button loading={submitting} onClick={() => {}} width="100%">
              Send email
            </Button>
          </Stack>
        </Box>

        <ResetPasswordBottomLink signedIn={signedIn} signInLink={signInLink} />
      </Stack>
    </Box>
  );
}
